import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import { API_URL } from "../config/app";

const URL = API_URL;

export const documentsService = {
  getAll,
  getSignedAll,
  getRejectAll,
  getPendingAll,
  getInvitedAll,
  getInvitedSignedAll,
  getInvitedPartialAll,
  getArchivedAll,
  createDocument,
  updateDocument,
  updateDocumentSignatureMethods,
  updateSignerSignatureMethods,
  deleteDocument,
  archiveDocument,
  getDocument,
  downloadXml,
  downloadPdfOriginal,
  downloadPdf,
  downloadVerificationCopy,
  downloadIdentityCopy,
  downloadNom151,
  downloadAll,
  uploadReferenceDocument,
  getReferenceDocument
};

function getAll(page, sort, company_id, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?company_id=' + company_id;
  if (page) {
    parameters += '&page=' + page
  }
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          sign_position: resp.attributes.sign_position,
          identity_copy_available: resp.attributes.identity_copy_available,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getSignedAll(page, sort, company_id, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?company_id=' + company_id;
  if (page) {
    parameters += '&page=' + page
  }
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents" + parameters + "&sign_status=3", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          sign_position: resp.attributes.sign_position,
          identity_copy_available: resp.attributes.identity_copy_available,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getRejectAll(page, sort, company_id, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?company_id=' + company_id;
  if (page) {
    parameters += '&page=' + page
  }
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents" + parameters + "&sign_status=4", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          sign_position: resp.attributes.sign_position,
          identity_copy_available: resp.attributes.identity_copy_available,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getPendingAll(page, sort, company_id, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?company_id=' + company_id;
  if (page) {
    parameters += '&page=' + page
  }
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents" + parameters + "&sign_status=1,2", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          sign_position: resp.attributes.sign_position,
          identity_copy_available: resp.attributes.identity_copy_available,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getInvitedAll(page, sort, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?page=' + page;
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents/invited" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getInvitedSignedAll(page, sort, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?page=' + page;
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents/invited" + parameters + "&sign_status=3", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getInvitedPartialAll(page, sort, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?page=' + page;
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents/invited" + parameters + "&sign_status=1,2", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function getArchivedAll(page, sort, company_id, search) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?company_id=' + company_id;
  if (page) {
    parameters += '&page=' + page
  }
  if (sort) {
    parameters += '&sort=' + sort
  } else {
    parameters += '&sort=createdAt,DESC'
  }
  if (search) {
    parameters += '&searchName=' + search
  } else {
    parameters += '&searchName='
  }

  return fetch(URL + "/documents/archived" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          uuid: resp.id,
          original_hash: resp.attributes.original_hash,
          file_name: resp.attributes.file_name,
          sign_status: resp.attributes.sign_status,
          signed: resp.attributes.signed,
          signature_mode: resp.attributes.signature_mode,
          owner: resp.attributes.owner,
          signed_at: resp.attributes.signed_at,
          created_at: new Date(resp.attributes.created_at).toLocaleString('en-US', { timeZone: 'America/Mexico_City' }),
          is_owner: resp.attributes.isOwner,
          signatures: resp.relationships.signatories.data
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })
}

function createDocument(document) {
  let formData = new FormData()
  document.signatures.forEach((signature, index) => {
    formData.append("signatures[" + index + "].name", signature.name)
    formData.append("signatures[" + index + "].email", signature.email)
    if (signature.rfc) {
      formData.append("signatures[" + index + "].rfc", signature.rfc)
    }
    if (signature.phone) {
      formData.append("signatures[" + index + "].phone", signature.phone)
    }
    if (signature.positions && signature.positions.length > 0) {
      formData.append("signatures[" + index + "].positions", JSON.stringify(signature.positions))
    }
    if (signature.restrictMethods && signature.allowed_signature_methods && signature.allowed_signature_methods.length > 0) {
      signature.allowed_signature_methods.forEach((method) => {
        formData.append("signatures[" + index + "].allowed_signature_methods", method)
      })
    }
  })
  document.spectators.forEach((spectator, index) => {
    formData.append("spectators[" + index + "].name", spectator.name)
    formData.append("spectators[" + index + "].email", spectator.email)
  })
  formData.append("sign_ordered", document.sortableSignatures ? "ACTIVE" : "INACTIVE")
  formData.append("document", document.pdf)
  formData.append("tries", document.tries.toString())
  formData.append("remember_every", document.remember_every.toString())
  formData.append("remember_at", document.remember_at)
  formData.append("sign_mode", document.sign_mode)
  formData.append("sign_position", document.sign_position)
  formData.append("mode_logo", document.mode_logo)
  formData.append("company_id", document.company_id)
  document.signatureTypes.forEach(type => {
    if (type === 'FIREL') {
      formData.append("allow_type_signatures", 'FIREL')
      formData.append("allow_type_signatures", 'TEPJF')
    } else {
      formData.append("allow_type_signatures", type)
    }
  })
  if (document.identityProviders) {
    document.identityProviders.forEach(provider => {
      formData.append("identity_providers", provider)
    })
  }
  if (document.lockPhoneForOtp) {
    formData.append("lock_phone_for_otp", document.lockPhoneForOtp)
  }
  if (document.customBranding) {
    formData.append("custom_branding", document.customBranding)
  }

  let headers = authHeader()
  delete headers['Content-Type']

  return fetch(URL + "/documents", {
    method:  'POST',
    headers: headers,
    body:    formData,
  }).then(handleResponse)
}

function updateDocument(document, company_id = null) {

  let formData = new FormData()
  if (!company_id) {
    document.signatures.forEach((signature, index) => {
      formData.append("signatures[" + index + "].name", signature.name);
      formData.append("signatures[" + index + "].email", signature.email);
      formData.append("signatures[" + index + "].rfc", signature.rfc);
    })
  } else {
    formData.append('company_id', company_id);
  }

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'PATCH',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/documents/" + document.uuid, requestOptions).then(handleResponse);
}

// Métodos de firma de un documento ya creado. identityProviders solo aplica con VERIFICAMEX;
// si va null, el backend conserva los actuales.
function updateDocumentSignatureMethods(documentUuid, allowTypeSignatures, identityProviders = null) {
  const requestOptions = {
    method: 'PATCH',
    headers: authHeader(),
    body: JSON.stringify({
      allow_type_signatures: allowTypeSignatures,
      identity_providers: identityProviders
    })
  };

  return fetch(URL + "/documents/" + documentUuid + "/signature_methods", requestOptions).then(handleResponse);
}

// Métodos de un firmante; una lista vacía le quita la restricción (usa los del documento).
function updateSignerSignatureMethods(documentUuid, signatureUuid, allowedSignatureMethods) {
  const requestOptions = {
    method: 'PATCH',
    headers: authHeader(),
    body: JSON.stringify({
      allowed_signature_methods: allowedSignatureMethods
    })
  };

  return fetch(URL + "/documents/" + documentUuid + "/signatures/" + signatureUuid + "/signature_methods", requestOptions).then(handleResponse);
}

function deleteDocument(document) {

  const requestOptions = {
    method: 'DELETE',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + document.uuid, requestOptions).then(handleResponse);
}

function archiveDocument(document) {

  const requestOptions = {
    method: 'PATCH',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + document.uuid + "/archive", requestOptions).then(handleResponse);
}

function downloadXml(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + uuid + "/xml", requestOptions).then(resp => resp.blob())
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '.xml';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function downloadPdfOriginal(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + uuid + "/download_original", requestOptions).then(resp => resp.blob())
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '_ORIGINAL' + '.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function downloadPdf(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + uuid + "/pdf", requestOptions).then(resp => resp.blob())
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '_FIRMADO' + '.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function downloadVerificationCopy(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  // Esta descarga sí puede responder error (el documento no aplica o falta que alguien firme): se revisa
  // la respuesta para mostrar el mensaje en lugar de descargar el error como si fuera el PDF.
  return fetch(URL + "/documents/" + uuid + "/verification_copy", requestOptions)
    .then(resp => resp.ok ? resp.blob() : handleResponse(resp))
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '_COPIA_CERTIFICADA' + '.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function downloadIdentityCopy(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  // Igual que la copia certificada, puede responder error (nadie firmó con identidad o falta que alguien
  // firme): se revisa la respuesta para mostrar el mensaje en lugar de descargarlo como si fuera el PDF.
  return fetch(URL + "/documents/" + uuid + "/identity_copy", requestOptions)
    .then(resp => resp.ok ? resp.blob() : handleResponse(resp))
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '_IDENTIFICACIONES' + '.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function downloadNom151(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + uuid + "/nom151", requestOptions).then(resp => resp.blob())
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '.asn1';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function downloadAll(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };

  return fetch(URL + "/documents/" + uuid + "/download_all", requestOptions).then(resp => resp.blob())
    .then(
      blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = uuid + '.zip';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
    )
    .catch(error => Promise.reject(error));
}

function getDocument(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/documents/" + uuid, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function uploadReferenceDocument(uuid, base64Pdf) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ file: base64Pdf })
  };

  return fetch(URL + "/documents/" + uuid + "/reference", requestOptions).then(handleResponse);
}

function getReferenceDocument(uuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/documents/" + uuid + "/reference", requestOptions)
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/pdf")) {
        return response.blob();
      }
      return response.text().then(text => {
        if (!text || text === "null" || text === '""') {
          return null;
        }
        try {
          return JSON.parse(text);
        } catch (e) {
          return text;
        }
      });
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
